export default "__VITE_ASSET__548756df__"